<template>
    <b-tabs content-class="mt-3" :value="activeTabIndex">
    <b-tab @click="goTo('log')" title="Overview">
        <router-view :booking="booking" :key="booking.id"></router-view>
    </b-tab>
    <b-tab title="Complete Log">
        <b-button variant="primary" :href="rootUrl + '/api/ext/log/' + booking.id">Download Playback Log (csv format)
        </b-button>
    </b-tab>
    <b-tab @click="goTo('report')" title="Report">
        <router-view :booking="booking" :key="booking.id"></router-view>
    </b-tab>
    </b-tabs>
</template>

<script>
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/plus'

export default {
  name: 'TabContainer',
  props: {
    booking: {
      type: Object,
      required: true
    },
  },
  components: {
  },
  computed: {
    activeTabIndex() {
      const name = this.$route.name
      if (name === 'report') return 2
      return 0
    }
  },
  methods: {
    goTo(routeName) {
      this.$router.push({ name: routeName, params: { bookingId: this.booking.id } })
    }
  },
  data() {
    return {
      rootUrl: process.env.VUE_APP_API_ROOT
    }
  },
}

</script>